import React from 'react';
import { colors } from '@/globalStyles';
import styled, { css } from 'styled-components';
import Accordion from '@mui/material/Accordion';

export const GridContainer = styled.div`
  display: grid;
  position: relative;
  width: 100%;
  justify-content: center;
  grid-gap: 20px;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  overflow: ${props => (props.$isGrey ? 'hidden' : 'unset')};
  height: ${props => (props.$isGrey && props.$expanded ? '100%' : 'unset')};
`;

export const AccordionHeaderWrapper = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  flex-direction: row;
`;

export const ScrollableContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding-bottom: 25px;
`;

export const BottomWrapper = styled.div`
  width: 100%;
  position: absolute;
  bottom: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: 1fr;
  grid-row-gap: 10px;
  grid-column-gap: 20px;
  position: relative;
  padding: 20px;
  background-color: #f4f4f4;
  border-radius: 4px;
`;

export const ApplyButton = styled.div`
  width: 100%;
  height: 60px;
  display: flex;
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.25);
  background-color: ${colors.primary};
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${colors.white};
`;

export const AccordionHeaderColors = styled.div`
  height: ${props => (props.$isGrey ? '90px' : 'unset')};
  min-height: 54px;
  display: flex;
  justify-content: space-between;

  ${props => props.$expanded && props.$isGrey && css`
    border-bottom: solid 1px ${colors.lightShadeGray};
    margin-bottom: 1px;
  `}

  * {
    color: ${props => (props.$isGrey ? colors.primary + ' !important' : 'unset')};
  }
`;

export const Icon = styled.img`
  width: 34px;
  height: 34px;
`;

export const AccordionStyled = styled(({ $scrollable, $isGrey, ...otherProps }) => <Accordion {...otherProps} />)`
  & .MuiButtonBase-root {
    min-height: auto !important;
  }

  & .MuiAccordionSummary-content {
    margin: 12px 0px !important;
  }

  & .MuiAccordionSummary-root {
    width: 100%;
  }

  & .MuiCollapse-root {
    ${props => props.$scrollable && css`overflow-y: auto;`};

    margin-top: ${props => (props.expanded && props.$isGrey ? '20px' : '0px')};
    margin-bottom: 2px;
  }
`;

export const TitleStyled = styled.div`
  font-size: 17px;
  font-family: IBMPlexSans;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
`;